import { Slide } from '@features/powerpoint';
import { TITLE } from '../../shared/dark-background-slide-master';
import { theme } from '@features/lci-report/domain/theme';

export const emailSlide = (): Slide => ({
  slideMaster: TITLE,
  texts: [
    {
      text: 'measurementaccountmanagement@inmarket.com',
      options: {
        fontSize: theme.fontSizes.content,
        color: theme.colors.white,
        h: 0.34,
        w: 5.33,
        x: 0.76,
        y: 3.75,
      },
    },
  ],
});
